// src/hooks/useDocumentContext.ts
import { useState, useCallback } from "react";
import { getEntireDocument } from "../helpers/word";
import { createLogger } from "../utils/logger";

const log = createLogger("DocumentContext");

export function useDocumentContext() {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [documentOoxml, setDocumentOoxml] = useState<string | null>(null);

  const getDocumentOoxml = useCallback(async () => {
    setIsLoading(true);
    setError(null);

    try {
      // Call Word.js helper to get the document content
      const ooxml = await getEntireDocument();
      setDocumentOoxml(ooxml);
      return ooxml;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : "Failed to get document content";
      setError(errorMessage);
      log.error("Error getting document content", {
        error: err instanceof Error ? err.message : String(err),
        stack: err instanceof Error ? err.stack : undefined,
        hasExistingDocument: !!documentOoxml,
      });
      return null;
    } finally {
      setIsLoading(false);
    }
  }, []);

  return {
    documentOoxml,
    isLoading,
    error,
    getDocumentOoxml,
    resetError: () => setError(null),
  };
}
